
import { setGA4Event } from "@dillon/Store/Handlers/Utilities/CustomTracking";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchCompleteSignIn,
} from "@insite/client-framework/Store/Context/Handlers/SignIn";

addToChainAfter(chain, DispatchCompleteSignIn, props => {
    // Verndale customization ticket: DSSM-414
    if (props.authenticatedSession) {
        const userID = props.authenticatedSession.userProfileId;
        setGA4Event([], "sign_in", { userID });
    }
    // End of Verndale customization ticket: DSSM-414
});


